// One RGBA8 texture for everything the political shaders look up: WebGPU allows 16 sampled
// textures per shader stage by default and the terrain material already uses most of them.
//
//        x: 0 ───────────── 1024
//   y: 0   ┌─────────────────────────┐
//          │ front-line distance     │  R: distance to the nearest front line (fronts.ts),
//          │ field, 1024 × 1024      │  G: width its end has left there; linear filter
//   y: 1024├──────────┬──────────────┤
//          │ per-hex  │   (unused)   │  claims and city-state rings by hex (claims.ts),
//          │ 512×337  │              │  read with textureLoad, so the filter never blends them
//          └──────────┴──────────────┘

import * as THREE from 'three/webgpu';
import { ROWS } from '../../core/grid.ts';

/** Side of the front-line field, in texels. */
export const FIELD_SIZE = 1024;
export const ATLAS_W = FIELD_SIZE;
/** The per-hex block starts on this row. */
export const HEX_BLOCK_Y = FIELD_SIZE;
export const ATLAS_H = FIELD_SIZE + ROWS;
export const CHANNELS = 4;

export class Atlas {
  readonly texture: THREE.DataTexture;
  readonly data = new Uint8Array(ATLAS_W * ATLAS_H * CHANNELS);

  constructor() {
    const tex = new THREE.DataTexture(this.data, ATLAS_W, ATLAS_H, THREE.RGBAFormat, THREE.UnsignedByteType);
    tex.magFilter = THREE.LinearFilter;
    tex.minFilter = THREE.LinearFilter;
    tex.wrapS = THREE.ClampToEdgeWrapping;
    tex.wrapT = THREE.ClampToEdgeWrapping;
    tex.generateMipmaps = false;
    tex.needsUpdate = true;
    this.texture = tex;
  }

  /** Upload after `data` changed. */
  touch(): void {
    this.texture.needsUpdate = true;
  }

  dispose(): void {
    this.texture.dispose();
  }
}
